import { useAuthRestApi } from '../common';
import { Observable } from 'rxjs';
import { IVirtualMachine, IVirtualMachineApi } from '@vivli/features/virtual-machine/infrastructure/interface';

export const useVirtualMachineApi = (): IVirtualMachineApi => {
    const { handleGet, handlePost } = useAuthRestApi();
    const getUserVms = (userId: string): Observable<IVirtualMachine[]> => {
        return handleGet<IVirtualMachine[]>(`/researchEnvironments/runningVms/${userId}`);
    };

    const getVms = (includeDeleted: boolean): Observable<IVirtualMachine[]> => {
        return handleGet<IVirtualMachine[]>(`/ResearchEnvironments?includeDeleted=${includeDeleted}`);
    };

    const getDataRequestVm = (dataRequestId: string): Observable<IVirtualMachine> => {
        return handleGet<IVirtualMachine>(`/dataRequests/${dataRequestId}/researchEnvironment`);
    };

    const getVm = (researchEnvironmentId: string): Observable<IVirtualMachine> => {
        return handleGet<IVirtualMachine>(`/researchEnvironments/${researchEnvironmentId}`);
    };

    const startResearchEnvironment = (dataRequestId: string): Observable<void> => {
        return handlePost(`/dataRequests/${dataRequestId}/researchEnvironment/requestToStart`);
    };

    const deprovisionResearchEnvironment = (researchEnvironmentId: string): Observable<IVirtualMachine> => {
        return handlePost(`/researchEnvironments/${researchEnvironmentId}/requestToDeprovision`);
    };

    const stopResearchEnvironment = (researchEnvironmentId: string): Observable<IVirtualMachine> => {
        return handlePost(`/researchEnvironments/${researchEnvironmentId}/requestToStop`);
    };

    const getGuacToken = (researchEnvironmentId: string): Observable<string> => {
        return handleGet(`/researchEnvironments/${researchEnvironmentId}/guactoken`);
    };

    const getAdminGuacToken = (researchEnvironmentId: string): Observable<string> => {
        return handleGet(`/researchEnvironments/${researchEnvironmentId}/adminguactoken`);
    };

    const getUserGuacToken = (researchEnvironmentId: string, userId: string): Observable<string> => {
        return handleGet(`/researchEnvironments/${researchEnvironmentId}/${userId}/guacusertoken`);
    };

    const getAdminPassword = (researchEnvironmentId: string): Observable<string> => {
        return handleGet(`/researchEnvironments/${researchEnvironmentId}/adminpass`);
    };

    return {
        getUserVms,
        getVms,
        getDataRequestVm,
        getVm,
        startResearchEnvironment,
        deprovisionResearchEnvironment,
        stopResearchEnvironment,
        getGuacToken,
        getAdminGuacToken,
        getUserGuacToken,
        getAdminPassword
    };
};
